import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  loading: false,
  propertyJourneyLoading: false,
  selectedUnit: {
    unitId: "",
    unitName: "",
    communityName: "",
    communityId: "",
    salesOrderId: "",
    imageUrl: "",
    unitType: "",
  },
  serviceChargeDetails: {},
  propertyJourney: {},
  unitDetails:[],
  serviceChargeLoading:false,
  permissionPersona: null
};

const livingInJourneySlice = createSlice({
  name: "livingInJourney",
  initialState: initialState,
  reducers: {
    updateLivingInJourney: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetLivingInJourney: () => {
      return initialState;
    },
  },
});

export const { resetLivingInJourney, updateLivingInJourney } =
  livingInJourneySlice.actions;
export default livingInJourneySlice.reducer;
